import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  saveBulletinSuccess,
  saveBulletinFailure,
  updateBulletinSuccess,
  updateBulletinFailure,
  deleteBulletinSuccess,
  deleteBulletinFailure,
} from "./bulletinActions";
import { saveBulletin, updateBulletin, deleteBulletin } from "./bulletin";

// 🔹 Save Bulletin
function* saveBulletinSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveBulletin, apiPayloadRequest);

    if (data?.type === 1) {
      const result = { ...apiPayloadRequest, ...data.data, bulletinObjId: data.bulletinObjId };
      yield put(saveBulletinSuccess(result));
      if (action.callback) action.callback({ type: 1, data: result });
    } else {
      yield put(saveBulletinFailure(data?.error || "Save failed"));
      if (action.callback) action.callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(saveBulletinFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// 🔹 Update Bulletin
function* updateBulletinSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(updateBulletin, apiPayloadRequest);

    if (data?.type === 1) {
      const result = { ...apiPayloadRequest, ...data.data };
      yield put(updateBulletinSuccess(result));
      if (action.callback) action.callback({ type: 1, data: result });
    } else {
      yield put(updateBulletinFailure(data?.error || "Update failed"));
      if (action.callback) action.callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(updateBulletinFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// 🔹 Delete Bulletin
function* deleteBulletinSaga(action) {
  try {
    const { _id, bulletinObjId } = action.payload;
    const data = yield call(deleteBulletin, { _id, bulletinObjId });

    if (data?.type === 1) {
      yield put(deleteBulletinSuccess({ bulletinObjId }));
      if (action.callback) action.callback({ type: 1, data: { bulletinObjId } });
    } else {
      yield put(deleteBulletinFailure(data?.error || "Delete failed"));
      if (action.callback) action.callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(deleteBulletinFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

export default function* bulletinWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_BULLETIN_REQUEST, saveBulletinSaga);
  yield takeLatest(actionTypes.UPDATE_BULLETIN_REQUEST, updateBulletinSaga);
  yield takeLatest(actionTypes.DELETE_BULLETIN_REQUEST, deleteBulletinSaga);
}
